import type { HTMLAttributes } from 'react';

export interface IconScaleStarsData {
  amount: number;
  onMouseOver?: (index: number) => void;
  onClick?: (index: number) => void;
}

export interface IconScaleStarsProps
  extends IconScaleStarsData,
    Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'onMouseOver'> {}
